import permissions from '../../data/permissions';

export default [
    {
        name: "PurchaseRequisitionCreate",
        path: "requisition",                                                                        
        component: () => import('./../../views/purchase/PurchaseRequisitionCreateView.vue'),
        meta: { requiresAuth: true, authorization: permissions.purchase_requisition.create }
    },
    {
        name: "PurchaseRequisitionDisplay",
        path: "requisition/:id",
        component: () => import('./../../views/purchase/PurchaseRequisitionDisplayView.vue'),
        meta: { requiresAuth: true, authorization: permissions.purchase_requisition.read }
    },
    {
        name: "PurchaseRequisitionEdit",
        path: "requisition/:id/edit",                                                                   
        component: () => import('./../../views/purchase/PurchaseRequisitionEditView.vue'),
        meta: { requiresAuth: true, authorization: permissions.purchase_requisition.update }
    },
    {
        name: "PurchaseRequisitionList",
        path: "requisitions",
        component: () => import('./../../views/purchase/PurchaseRequisitionListView.vue'),
        meta: { requiresAuth: true, authorization: permissions.purchase_requisition.index }
    }
];